<template lang="pug">
  component(:is="componentType", :type="iconType", :image="imagePath")
</template>
<script>
  import Icon from 'modules/components/FlashReport/Icon';
  import IconPlan from 'modules/components/FlashReport/IconPlan';
  import IconUser from 'modules/components/FlashReport/IconUser';

  export default {
    components: {
      Icon,
      IconPlan,
      IconUser,
    },
    props: {
      type: { type: String, default: '' },
      imagePath: { type: String, default: '' },
    },
    computed: {
      componentType() {
        if (this.type === 'profile') {
          return 'icon-user';
        }
        if (this.type === 'footprint' || this.type === 'home') {
          return 'icon';
        }
        if (this.type === 'plan_and_footprint' || this.type === 'plan_and_home') {
          return 'icon-plan';
        }
        return 'icon';
      },
      iconType() {
        if (this.componentType === 'icon-user') {
          return undefined;
        }
        if (this.type === 'footprint' || this.type === 'plan_and_footprint') {
          return 'footprints';
        }
        if (this.type === 'home' || this.type === 'plan_and_home') {
          return 'home';
        }
        return undefined;
      },
    },
  };
</script>
